var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatherPointed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467.119 241.953L352 288H446.338C438.627 302.852 430.051 317.279 420.465 331.014L288 384H373.65C314.314 436.707 229.619 464.289 109.166 436.772L40.969 504.969C31.589 514.349 16.405 514.343 7.031 504.969C-2.344 495.594 -2.344 480.406 7.031 471.031L260.426 217.637C265.271 211.361 265.068 202.443 259.312 196.688C253.062 190.438 242.937 190.438 236.687 196.688L68.115 365.26C24.559 58.004 366.914 8.115 478.865 0.082C497.73 -1.271 513.271 14.27 511.918 33.135C508.66 78.526 498.461 161.828 467.119 241.953Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherPointed);
export default __webpack_public_path__ + "static/media/feather-pointed.fe1d756b911821f0cde7bf2542b15eb5.svg";
export { ForwardRef as ReactComponent };